"use strict";
exports.__esModule = true;
exports.capitalize = void 0;
var capitalize = function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
exports.capitalize = capitalize;
